// 域名配置

// 无极看板域名
export const WUJI_HOST = 'https://open.wuji.woa.com';

export const DOC_DOMAIN = 'https://bugly.tds.qq.com/docs';
